import { FC } from 'react';

import { Badge } from '@new/common/ui/Badge/Badge';
import type { EvaluationStatus, TranscriptStatus } from '../types';
import {
  getEvaluationStatusLabel,
  getEvaluationStatusVariant,
  getTranscriptStatusLabel,
  getTranscriptStatusVariant,
} from '../helpers/status';

interface EvaluationStatusBadgeProps {
  status: EvaluationStatus;
  className?: string;
}

export const EvaluationStatusBadge: FC<EvaluationStatusBadgeProps> = ({ status, className }) => (
  <Badge variant={getEvaluationStatusVariant(status)} className={className}>
    {getEvaluationStatusLabel(status)}
  </Badge>
);

interface TranscriptStatusBadgeProps {
  status: TranscriptStatus;
  className?: string;
}

export const TranscriptStatusBadge: FC<TranscriptStatusBadgeProps> = ({ status, className }) => (
  <Badge variant={getTranscriptStatusVariant(status)} className={className}>
    {getTranscriptStatusLabel(status)}
  </Badge>
);
